// 定义中文语言包对象
export default {
    Language: '简体中文',
    signIn: '登录',
    navigateBar: {
        homePage: '首页',
        newsInformation: '新闻资讯',
        productCenter: '产品中心',
        aboutUs: '公司简介',
    },
    title: {
        companyName: '泽科技',
        slogan: '追求极致创意',
        newsInformation: '新闻资讯',
        productCenter: '产品中心',
        aboutUs: '走进CCT',
        companyNews: '公司新闻',
        industryNews: '行业动态',
    },
    aboutUs:{
        aboutUs: '公司简介',
        aboutUsText: 'CCT (HK) LIMITED 成立于2007年，是电子烟行业最早的开拓者之一，已形成完整的质量管理体系和强大的研发能力，拥有400多项国内外专利授权记录。',
        developmentHistory: '发展历程',
        corporateCulture: '企业文化',
        corporateCultureText1: '用户至上： 始终将用户需求放在首位，致力于提供安全、优质、创新的产品和服务',
        corporateCultureText2: '诚信经营： 坚持诚信为本，遵守法律法规，恪守商业道德，维护行业良好生态',
        corporateCultureText3: '创新驱动： 鼓励创新思维，持续投入研发，推动技术进步，为用户带来更优质的产品体验',
        corporateCultureText4: '合作共赢： 与合作伙伴携手共进，建立长期稳定的合作关系，实现互利共赢',
        corporateCultureText5: '社会责任： 积极履行社会责任，关注青少年保护，倡导理性消费，为社会发展贡献力量',
        qualificationAndHonor: '国际资质认证',
        team: '团队风采',
        cooperativePartner: '合作伙伴',
        clickImage: '点击图片查看大图',
    },
    footer: {
        aboutUs: '走进CCT',
        newsInformation: '新闻资讯',
        productCenter: '产品中心',
        contactUs: '联系我们',
        child:{
            developmentHistory: '发展历程',
            corporateCulture: '企业文化',
            qualificationAndHonor: '国际资质认证',
            cooperativePartner: '合作伙伴',
            companyNews: '公司新闻',
            industryNews: '行业动态',
            productIntroduction: '产品介绍',
            email: '邮箱：garyking0073@gmail.com',
            phone: '电话：852-88881234',
            address: '地址：FLAT G 2/F LEAPONT CTR 18-28 WO LIU HANG RD FO TAN HONG KONG',
        }
    },

};
